import * as React from "react";
import type { SVGProps } from "react";

const PaymentConfirmation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.365 65.463V41.389V42.367V29.352V65.463ZM24.365 35.37H72.62V29.352H24.365V35.37ZM47.512 71.482H24.365C22.706 71.482 21.286 70.892 20.105 69.714C18.924 68.535 18.333 67.118 18.333 65.463V29.352C18.333 27.697 18.924 26.28 20.105 25.101C21.286 23.923 22.706 23.333 24.365 23.333H72.62C74.278 23.333 75.698 23.923 76.879 25.101C78.06 26.28 78.651 27.697 78.651 29.352V45.15C76.841 43.897 74.881 42.956 72.77 42.329C70.659 41.702 68.497 41.389 66.286 41.389C63.571 41.389 60.958 41.915 58.444 42.969C55.931 44.022 53.72 45.502 51.81 47.407H24.365V65.463H45.702C45.853 66.516 46.079 67.544 46.381 68.548C46.683 69.551 47.06 70.529 47.512 71.482ZM71.639 69.601L73.75 67.494L68.095 61.852V53.426H65.079V63.056L71.639 69.601ZM66.663 77.5C62.44 77.5 58.859 76.046 55.919 73.137C52.978 70.228 51.508 66.667 51.508 62.454C51.508 58.241 52.978 54.68 55.919 51.771C58.859 48.862 62.44 47.407 66.663 47.407C70.835 47.407 74.378 48.874 77.294 51.809C80.209 54.743 81.667 58.291 81.667 62.454C81.667 66.617 80.209 70.165 77.294 73.099C74.378 76.033 70.835 77.5 66.663 77.5Z"
      fill="#050033"
    />
  </svg>
);

export default PaymentConfirmation;
